(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["scentemy-more-ways"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('scentemy-more-ways-v16')) {
const MW_COLLECTION_IDS = ["gid://shopify/Collection/338838683816", "gid://shopify/Collection/338838782120", "gid://shopify/Collection/338838913192", "gid://shopify/Collection/338838978728", "gid://shopify/Collection/338839044264", "gid://shopify/Collection/338839109800", "gid://shopify/Collection/338839142568", "gid://shopify/Collection/338839175336", "gid://shopify/Collection/338839240872", "gid://shopify/Collection/338839273640", "gid://shopify/Collection/338839306408", "gid://shopify/Collection/338839371944", "gid://shopify/Collection/338839437480", "gid://shopify/Collection/338839470248", "gid://shopify/Collection/338839503016", "gid://shopify/Collection/338839568552", "gid://shopify/Collection/338839601320", "gid://shopify/Collection/338839666856", "gid://shopify/Collection/346104004776", "gid://shopify/Collection/348437479592", "gid://shopify/Collection/348719579304"];
const MW_COLLECTION_QUERY = "query ScentemyMscCollections($ids:[ID!]!,$msc:String!,$country:CountryCode) @inContext(country:$country){nodes(ids:$ids){... on Collection{id products(first:100,filters:[{productMetafield:{namespace:\"custom\",key:\"msc\",value:$msc}}]){nodes{id handle title productType availableForSale}pageInfo{hasNextPage endCursor}}}}}";
const MW_COLLECTION_PAGE_QUERY = "query ScentemyMscCollectionPage($id:ID!,$msc:String!,$after:String!,$country:CountryCode) @inContext(country:$country){node(id:$id){... on Collection{id products(first:100,after:$after,filters:[{productMetafield:{namespace:\"custom\",key:\"msc\",value:$msc}}]){nodes{id handle title productType availableForSale}pageInfo{hasNextPage endCursor}}}}}";

  customElements.define('scentemy-more-ways-v16', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) {this.resumeAfterAbort = this.loading;this.startSlider();this.watchEditor();this.scheduleMatches();return;}
      this.ready = true;
      this.form = this.querySelector('form');
      this.status = this.querySelector('[data-mw-status]');
      this.button = this.querySelector('[type=submit]');
      this.buttonLabel = this.button.textContent.trim();
      this.money = new Intl.NumberFormat(this.dataset.locale || undefined, {style:'currency',currency:this.dataset.currency,currencyDisplay:'narrowSymbol'});
      this.track = this.querySelector('[data-mw-track]');
      this.addEventListener('change', event => {
        const card = event.target.closest('.smw2-card');
        if (event.target.matches('[data-mw-product]')) {
          const variants = [...event.target.closest('.smw2-card').querySelectorAll('[data-mw-variant]')];
          if (event.target.checked && !variants.some(v => v.checked) && variants[0]) variants[0].checked = true;
          if (!event.target.checked) variants.forEach(v => {v.checked = false;});
          this.syncCardImage(card);
        } else if (event.target.matches('[data-mw-variant]')) {
          if (event.target.checked) card.querySelectorAll('[data-mw-variant]').forEach(input => {input.checked = input === event.target;});
          this.syncCardImage(card,event.target.checked ? event.target : null);
        }
        this.update();
      });
      this.addEventListener('click', event => {
        if (event.target.closest('[data-mw-retry]')) {this.loadMatches();return;}
        const control = event.target.closest('[data-mw-slide]');
        if (!control) return;
        const card = this.track.querySelector('.smw2-card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track.querySelector('.smw2-grid')).columnGap) || 0;
        const step = card.getBoundingClientRect().width + gap;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        this.track.scrollBy({left:step * Number(control.dataset.mwSlide) * (rtl ? -1 : 1),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      });
      this.form.addEventListener('submit', event => this.addItems(event));
      this.update();
      this.startSlider();
      this.watchEditor();
      this.scheduleMatches();
    }
    scheduleMatches() {
      if (this.loaded || this.loading || this.scheduled || !this.isConnected) return;
      this.scheduled = true;
      if (window.Shopify?.designMode) {
        this.scheduled = false;
        this.loadMatches();
        return;
      }
      const queue = () => {
        this.nearObserver?.disconnect();
        const run = () => {
          this.idleHandle = null;
          this.scheduled = false;
          if (this.isConnected) this.loadMatches();
        };
        if ('requestIdleCallback' in window) this.idleHandle = window.requestIdleCallback(run, {timeout:1500});
        else this.delayHandle = setTimeout(run, 100);
      };
      this.afterPageLoad = () => {
        if (!this.isConnected) return;
        if ('IntersectionObserver' in window) {
          this.nearObserver = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) queue();
          }, {rootMargin:'600px 0px'});
          this.nearObserver.observe(this);
        } else queue();
      };
      if (document.readyState === 'complete') this.afterPageLoad();
      else window.addEventListener('load', this.afterPageLoad, {once:true});
    }
    showLoadState(state) {
      this.dataset.loadState = state;
      this.setAttribute('aria-busy', String(state === 'pending'));
      const loader = this.querySelector('[data-mw-loader]');
      loader.hidden = state === 'ready';
      this.form.hidden = state !== 'ready';
      const failed = state === 'error';
      loader.querySelector('[data-mw-loading-text]').hidden = failed;
      loader.querySelector('[data-mw-loading-error]').hidden = !failed;
      loader.querySelector('[data-mw-retry]').hidden = !failed;
      loader.querySelector('[data-mw-skeleton]').hidden = failed;
    }
    applyCardCopy(card, config, fragrance) {
      this.cardDefaults ||= new WeakMap();
      if (!this.cardDefaults.has(card)) {
        this.cardDefaults.set(card, {
          title:card.querySelector('[data-mw-category-name]').textContent,
          intro:card.querySelector('.smw2-description')?.textContent || '',
          badge:card.querySelector('.smw2-badge')?.textContent || '',
          benefits:[...card.querySelectorAll('.smw8-benefits li')].map(li => li.textContent)
        });
      }
      const defaults = this.cardDefaults.get(card);
      const clean = value => typeof value === 'string' ? value.trim() : '';
      const category = clean(card.dataset.productType).toLowerCase();
      const override = {};
      for (const item of config.overrides || []) {
        if (clean(item.category).toLowerCase() !== category) continue;
        for (const key of ['title','intro','benefit_1','benefit_2','blockId','editorAttributes']) {
          if (clean(item[key])) override[key] = clean(item[key]);
        }
      }
      card.querySelector('[data-mw-card-fragrance]').textContent = this.dataset.inspiredPrefix + ' ' + fragrance;
      card.querySelector('[data-mw-category-name]').textContent = override.title || defaults.title;
      const description = card.querySelector('.smw2-description');
      if (description) {description.textContent = override.intro || defaults.intro;description.hidden = !config.showDescriptions;}
      const badge = card.querySelector('.smw2-badge');
      if (badge) {badge.textContent = config.badge || defaults.badge;badge.hidden = !config.showBadge;}
      const benefits = card.querySelector('.smw8-benefits');
      if (benefits) {
        const labels = [override.benefit_1 || defaults.benefits[0],override.benefit_2 || defaults.benefits[1]].filter(Boolean);
        benefits.replaceChildren(...labels.map(label => {const li=document.createElement('li');li.textContent=label;return li;}));
        benefits.hidden = !config.showBenefits || !labels.length;
      }
      if (window.Shopify?.designMode) {
        card.dataset.mwBlockId = override.blockId || '';
        card.removeAttribute('data-shopify-editor-block');
        if (override.editorAttributes) {
          const attributes = new DOMParser().parseFromString('<div '+override.editorAttributes+'></div>','text/html').body.firstElementChild;
          const blockData = attributes?.getAttribute('data-shopify-editor-block');
          if (blockData) card.setAttribute('data-shopify-editor-block',blockData);
        }
      }
    }
    refreshEditor() {
      if (!window.Shopify?.designMode) return;
      if (!this.loaded) {this.scheduleMatches();return;}
      const config = JSON.parse(this.querySelector('[data-mw-config]').textContent);
      for (const card of this.querySelectorAll('.smw2-card')) this.applyCardCopy(card,config,this.fragrance);
      this.updateNavigation();
    }
    revealEditorBlock(id) {
      this.pendingBlockId = id;
      const card = [...this.querySelectorAll('.smw2-card')].find(item => item.dataset.mwBlockId === id);
      if (card) {card.scrollIntoView({block:'nearest',inline:'center',behavior:'auto'});this.pendingBlockId = null;}
    }
    watchEditor() {
      if (!window.Shopify?.designMode) return;
      this.configObserver?.disconnect();
      this.configObserver = new MutationObserver(() => this.refreshEditor());
      this.configObserver.observe(this.querySelector('[data-mw-config]'),{childList:true,subtree:true,characterData:true});
    }

    async findMscProducts(msc, config, signal) {
      const ids = [...new Set([...MW_COLLECTION_IDS, ...(config.extraCollectionIds || [])])];
      const country = this.dataset.country || 'ZA';
      const request = async (query, variables) => {
        const response = await fetch('/api/2026-07/graphql.json', {
          method:'POST', credentials:'same-origin', signal, priority:'low',
          headers:{'Content-Type':'application/json',Accept:'application/json'},
          body:JSON.stringify({query,variables:{...variables,msc,country}})
        });
        if (!response.ok) throw Error('Shopify matching request failed: ' + response.status);
        const result = await response.json();
        if (result.errors?.length || !result.data) throw Error('Shopify could not complete the MSC lookup.');
        return result.data;
      };
      const data = await request(MW_COLLECTION_QUERY,{ids});
      if (!Array.isArray(data.nodes) || data.nodes.length !== ids.length || data.nodes.some(n=>!n?.products)) throw Error('A matching category collection is unavailable.');
      const products = new Map();
      const add = collection => {
        for (const product of collection.products.nodes) {
          const id = product.id?.match(/^gid:\/\/shopify\/Product\/(\d+)$/)?.[1];
          if (!id || !/^[a-z0-9][a-z0-9-]*$/.test(product.handle || '')) throw Error('Invalid matching product identity.');
          products.set(id,{...product,numericId:id});
        }
        if (products.size > 1000) throw Error('Unexpectedly broad MSC results. Check the custom.msc filter setting.');
      };
      for (const collection of data.nodes) {
        add(collection);
        let page = collection;
        const seen = new Set();
        while (page.products.pageInfo.hasNextPage) {
          const after = page.products.pageInfo.endCursor;
          if (!after || seen.has(after)) throw Error('Invalid matching-product pagination.');
          seen.add(after);
          if (seen.size > 20) throw Error('Unexpectedly broad MSC results.');
          const next = await request(MW_COLLECTION_PAGE_QUERY,{id:collection.id,after});
          if (!next.node?.products || next.node.id !== collection.id) throw Error('Incomplete category response.');
          page = next.node;
          add(page);
        }
      }
      return [...products.values()];
    }
    async loadMatches() {
      if (this.loading || this.loaded) return;
      this.loading = true;
      this.hidden = false;
      this.showLoadState('pending');
      const controller = new AbortController();
      this.lookupController = controller;
      const timeout = setTimeout(() => controller.abort(), 30000);
      try {
        let config = JSON.parse(this.querySelector('[data-mw-config]').textContent);
        const msc = this.dataset.msc.trim().toUpperCase();
        if (!/^SCENT\d{3,6}$/.test(msc)) throw Error('Missing or invalid MSC.');
        const products = await this.findMscProducts(msc,config,controller.signal);
        const candidates = products.filter(p=>p.availableForSale && p.numericId !== this.dataset.productId);
        const cards = new Map();
        for (let offset=0;offset<candidates.length;offset+=20) {
          const batch = candidates.slice(offset,offset+20);
          const expected = new Set(batch.map(p=>p.numericId));
          const url = new URL(this.dataset.searchUrl,location.origin);
          url.searchParams.set('q',[msc,...batch.map(p=>p.handle)].join('|'));
          url.searchParams.set('type','product');
          url.searchParams.set('view','scentemy-more-ways');
          const preview = new URL(location.href).searchParams.get('preview_theme_id');
          if (preview && /^\d+$/.test(preview)) url.searchParams.set('preview_theme_id',preview);
          const response = await fetch(url.href,{headers:{Accept:'text/html'},credentials:'same-origin',priority:'low',signal:controller.signal});
          if (!response.ok) throw Error('Product-card rendering failed: '+response.status);
          const doc = new DOMParser().parseFromString(await response.text(),'text/html');
          const result = doc.querySelector('template[data-mw-results]');
          if (!result || result.dataset.mode !== 'handles' || result.dataset.msc !== msc) throw Error('The saved More Ways section is not the current version.');
          for (const card of result.content.querySelectorAll('.smw2-card')) {
            if (card.dataset.msc !== msc || !expected.has(card.dataset.productId)) throw Error('Shopify returned a card outside the requested MSC.');
            cards.set(card.dataset.productId,card);
          }
        }
        if (controller.signal.aborted || !this.isConnected) return;
        const allCards = [...cards.values()];
        const perfume = products.find(p=>p.productType==='Perfumes');
        const decoder = document.createElement('textarea');
        decoder.innerHTML = (perfume?.title || config.productTitle || msc).replaceAll('<','&lt;');
        const fragrance = decoder.value.replace(/^inspired\s+by\s+/i,'').trim();
        config = JSON.parse(this.querySelector('[data-mw-config]').textContent);
        this.fragrance = fragrance;
        const order = config.categoryOrder || [];
        const rank = type => { const index = order.indexOf(type); return index < 0 ? order.length : index; };
        const matches = allCards.filter(card => card.dataset.productId !== this.dataset.productId)
          .sort((a,b) => rank(a.dataset.productType) - rank(b.dataset.productType));
        const fragment = document.createDocumentFragment();
        for (const card of matches) {
          this.applyCardCopy(card,config,fragrance);
          for (const input of card.querySelectorAll('[data-mw-variant]')) {
            const oldId = input.id;
            input.id = this.track.id + '-' + input.value;
            input.name = this.track.id + '-' + card.dataset.productId;
            for (const label of card.querySelectorAll('label[for]')) if (label.htmlFor === oldId) label.htmlFor = input.id;
          }
          fragment.appendChild(card);
        }
        this.track.querySelector('.smw2-grid').replaceChildren(fragment);
        const heading = this.querySelector('[data-mw-heading]');
        if (config.heading) heading.textContent = config.heading.replaceAll('[fragrance]',fragrance);
        else heading.querySelector('.smw4-heading-name').textContent = this.dataset.inspiredPrefix + ' ' + fragrance;
        this.loaded = true;
        this.showLoadState('ready');
        this.hidden = matches.length === 0;
        this.update();
        requestAnimationFrame(() => {this.updateNavigation();if (this.pendingBlockId) this.revealEditorBlock(this.pendingBlockId);});
      } catch (error) {
        controller.abort();
        if (this.isConnected) this.showLoadState('error');
        if (error.name !== 'AbortError') console.warn('Scentemy matching products:', error.message);
      } finally {
        clearTimeout(timeout);
        this.loading = false;
        if (this.resumeAfterAbort && this.isConnected) {this.resumeAfterAbort = false;this.scheduleMatches();}
      }
    }

    syncCardImage(card, preferred) {
      if (!card) return;
      const selected = [...card.querySelectorAll('[data-mw-variant]:checked')];
      const previous = selected.find(input => input.value === card.dataset.mwDisplayedVariant);
      const active = preferred || previous || selected[selected.length - 1];
      const target = card.querySelector('.smw2-image');
      const source = active
        ? [...card.querySelectorAll('template[data-mw-variant-image]')].find(template => template.dataset.mwVariantImage === active.value)
        : card.querySelector('template[data-mw-default-image]');
      const fallback = card.querySelector('template[data-mw-default-image]');
      if (target && (source || fallback)) target.replaceChildren((source || fallback).content.cloneNode(true));
      card.dataset.mwDisplayedVariant = active?.value || '';
    }
    startSlider() {
      this.track?.removeEventListener('scroll', this.onScroll);
      this.resizeObserver?.disconnect();
      this.setAttribute('dir', getComputedStyle(this.track).direction || 'ltr');
      this.onScroll = () => this.updateNavigation();
      this.track.addEventListener('scroll', this.onScroll, {passive:true});
      this.resizeObserver = new ResizeObserver(() => this.updateNavigation());
      this.resizeObserver.observe(this.track);
      this.updateNavigation();
    }
    disconnectedCallback() {
      this.lookupController?.abort();
      this.nearObserver?.disconnect();
      this.configObserver?.disconnect();
      window.removeEventListener('load',this.afterPageLoad);
      if (this.idleHandle != null && 'cancelIdleCallback' in window) window.cancelIdleCallback(this.idleHandle);
      clearTimeout(this.delayHandle);
      this.scheduled = false;
      this.track?.removeEventListener('scroll', this.onScroll);
      this.resizeObserver?.disconnect();
    }
    updateNavigation() {
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const position = Math.abs(this.track.scrollLeft);
      this.querySelector('[data-mw-slide="-1"]').disabled = position < 2;
      this.querySelector('[data-mw-slide="1"]').disabled = position >= max - 2;
    }
    update() {
      this.querySelectorAll('[data-mw-product]').forEach(product => {
        const card = product.closest('.smw2-card');
        product.checked = !!card.querySelector('[data-mw-variant]:checked');
        card.classList.toggle('is-selected',product.checked);
        const badge = card.querySelector('[data-mw-selected]');
        if (badge) badge.hidden = !product.checked;
        product.disabled = !!this.busy;
      });
      const selected = [...this.querySelectorAll('.smw2-card')].map(card => card.querySelector('[data-mw-variant]:checked')).filter(Boolean);
      const total = selected.reduce((sum,input) => sum + Number(input.dataset.price),0);
      this.button.textContent = selected.length ? this.buttonLabel + ' — ' + this.money.format(total / 100) : this.buttonLabel;
      this.button.disabled = !!this.busy || !selected.length;
    }
    setBusy(busy) {
      this.busy = busy;
      this.querySelectorAll('[data-mw-variant]').forEach(input => {input.disabled = busy;});
      this.form.setAttribute('aria-busy',String(busy));
      this.update();
    }
    async openCart(trigger) {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer?.getSectionsToRender || !drawer?.renderContents) throw Error('Drawer unavailable');
      const root = window.Shopify?.routes?.root || '/';
      const sections = drawer.getSectionsToRender();
      const url = new URL(root + 'cart', location.origin);
      url.searchParams.set('sections',sections.map(s => s.id).join(','));
      const response = await fetch(url.href,{headers:{Accept:'application/json'}});
      if (!response.ok) throw Error('Drawer refresh failed');
      const html = await response.json();
      if (!sections.every(s => html[s.id] && new DOMParser().parseFromString(html[s.id],'text/html').querySelector(s.selector || '.shopify-section'))) throw Error('Missing drawer section');
      drawer.setActiveElement?.(trigger);
      drawer.renderContents({sections:html});
    }
    async addItems(event) {
      event.preventDefault();
      if (this.busy) return;
      const items = [...this.querySelectorAll('.smw2-card')].map(card => card.querySelector('[data-mw-variant]:checked')).filter(Boolean).map(input => ({id:input.value,quantity:1}));
      if (!items.length) {this.status.textContent=this.dataset.empty;return;}
      this.setBusy(true);
      this.status.textContent = this.dataset.adding;
      const root = window.Shopify?.routes?.root || '/';
      const cart = document.querySelector('cart-drawer');
      const sections = cart?.getSectionsToRender?.() || [];
      let added = false;
      try {
        cart?.setActiveElement?.(this.button);
        const response = await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items,sections:sections.map(section=>section.id),sections_url:location.pathname})});
        const data = await response.json();
        if (!response.ok || data.status) {this.status.textContent=String(data.description||data.message||this.dataset.error);return;}
        added = true;
        this.querySelectorAll('[data-mw-variant]:checked').forEach(input => {input.checked=false;});
        this.querySelectorAll('.smw2-card').forEach(card => this.syncCardImage(card));
        this.status.textContent=this.dataset.success;
        if (cart && sections.length && sections.every(section => {
          const html=data.sections?.[section.id];
          return html && new DOMParser().parseFromString(html,'text/html').querySelector(section.selector||'.shopify-section');
        })) {cart.classList.remove('is-empty');cart.renderContents(data);}
        else {await this.openCart(this.button);}
      } catch(error) {this.status.textContent=added?(this.dataset.success+' '+this.dataset.drawerError):this.dataset.uncertain;}
      finally {this.setBusy(false);}
    }
  });
}
if (window.Shopify?.designMode) {
  document.addEventListener('shopify:section:load',event => {
    event.target.querySelectorAll('scentemy-more-ways-v16').forEach(element => element.refreshEditor());
  });
  document.addEventListener('shopify:block:select',event => {
    const section = event.target.closest('.shopify-section');
    section?.querySelectorAll('scentemy-more-ways-v16').forEach(element => element.revealEditorBlock(event.detail.blockId));
  });
}

  } catch(e) { console.error(e); }
})();
})();
